module.exports = __webpack_public_path__ + "img/historical_route.738ab99d.png";